import Resource from './resource';
import request from "../utils/request";

class StudentsNotebook extends Resource {
    constructor() {
        super('students_notebook');
    }

    store(resource) {
        return request({
            url: `/students_notebook/store`,
            method: 'post',
            data: resource
        });
    }

    list(resource) {
        return request({
            url: `/students_notebook/list`,
            method: 'POST',
            data: resource
        });
    }

    delete(id) {
        return request({
            url: `/students_notebook/delete/${id}`,
            method: 'delete',
        });
    }

    update(id, resource) {
        return request({
            url: `/students_notebook/update/${id}`,
            method: 'post',
            data: resource
        });
    }

    show(id) {
        return request({
            url: `/students_notebook/show/${id}`,
            method: 'get',
        });
    }

    lookups(resource) {
        return request({
            url: `/students_notebook/lookups`,
            method: 'post',
            data: resource
        });
    }
}

export { StudentsNotebook as default };
